import { Model } from "@vuex-orm/core";
import VotingCategory from "./VotingCategory";
import BuildingOwnerBuildingLot from "./BuildingOwnerBuildingLot";

export default class BuildingOwnerVotingRight extends Model {
  static get entity() {
    return "building_owner_voting_rights";
  }
  static fields() {
    return {
      id: this.attr(null),
      building_owner_has_building_lot_id: this.attr(null),
      voting_category_id: this.attr(null),
      parts: this.attr(null),

      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      votingCategory: this.belongsTo(VotingCategory, "voting_category_id"),

      // HACK: article 22
      buildingOwnerBuildingLot: this.belongsTo(
        BuildingOwnerBuildingLot,
        "building_owner_has_building_lot_id"
      ),

      agency_id: this.attr(null),
    };
  }
}
